import React from "react";
import {logHistoryService} from "../jwt/_services/security/logHistoryService";

export const modelsProvider = {
    getOptions,
};

async function getOptions(){
    try {
        const listItems = await logHistoryService.listAllModelsToDoTaks();
        return listItems.map((itemData) => {
            const { name } = itemData
            return (
                {
                    id: name,
                    value: name,
                    label: <div><label>{name}</label></div>
                }
            )
        });
    } catch (error) {
       console.log(error.message)
    }
}